import React from "react";
import app from "../../package.json";

const Footer = () => {
  return (
    <footer className="footer">
      <a className="footer__copyright" href="https://ui8.net/terms"
        rel="noopener noreferrer"
        target="_blank"
      >&copy; 2020, UI8 LLC. ({app.version})</a>
      <a className="footer__btn btn"
        href="https://ui8.net/ui8/products/sapiens-character-builder"
        rel="noopener noreferrer">Purchase Full Library</a>
      <div className="footer__links">
        <a className="footer__link" href="https://ui8.net/licensing?status=6"
          rel="noopener noreferrer"
          target="_blank">Licensing</a>
        <a className="footer__link" href="https://ui8.net/privacy-policy"
          rel="noopener noreferrer"
          target="_blank">Privacy Policy</a>
      </div>
    </footer>
  );
};

export default Footer;
